import React from "react";
import { IMG, APP_STORE_URL } from "../data/mock";

export default function Hero() {
  return (
    <section id="top" className="pt-[142px]">
      <div className="max-w-4xl mx-auto px-5 text-center pt-16 pb-2 md:pt-24 md:pb-4">
        <h1 className="font-serif-display text-[#68c2d5] text-[2.6rem] md:text-[3.75rem] font-normal leading-none animate-[fadeInUp_0.7s_ease]">
          Life With Abba
        </h1>
        <h2 className="font-serif-display text-[#1f1f1f] text-3xl md:text-[2.75rem] font-normal mt-4 md:mt-6 leading-tight">
          Share life with your Heavenly Father.
        </h2>
        <p className="font-serif-body text-[#333] text-[15px] md:text-[17px] mt-5 flex items-center justify-center flex-wrap gap-x-1.5">
          God hath sent forth the Spirit of his Son
          <img src={IMG.miniLogo} alt="" className="inline h-5 w-auto" />
          into your hearts, crying,
          <strong className="text-[#68c2d5]">Abba</strong>, Father. - Gal 4:6
        </p>

        <div className="mt-9 max-w-[600px] mx-auto">
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noreferrer"
            className="ios-btn shadow-[0_3px_12px_rgba(0,0,0,0.18)]"
          >
            <img src={IMG.apple} alt="" />
            <span className="font-serif-display">Get The iOS App Today!</span>
          </a>
        </div>
      </div>
    </section>
  );
}
